enum ModalType {
  CREATE_CONTRACT = "create",
  MODEL_OPTIONS = "model",
}
export default ModalType;
